import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

// Builds uses the same Cognito environments as the dashboard. Unknown pools must
// configure their endpoint and channel explicitly, rather than receiving prod builds.
const BUILD_ENVIRONMENTS = {
  "us-west-2_Hf3Ir6czx": {
    baseURL: "https://0boj2tkkn1.execute-api.us-west-2.amazonaws.com",
    channel: "prod",
  },
  "us-west-2_RyOYD707f": {
    baseURL: "https://208suoiux0.execute-api.us-west-2.amazonaws.com",
    channel: "staging",
  },
};

export async function getLatestEduRelease({ signal } = {}) {
  const environment = BUILD_ENVIRONMENTS[process.env.REACT_APP_USER_POOL_ID];
  const baseURL = process.env.REACT_APP_API_BUILDS_URL || environment?.baseURL;
  const channel = process.env.REACT_APP_BUILDS_CHANNEL || environment?.channel;
  if (!baseURL || !channel) throw new Error("Builds API is not configured.");

  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  if (!token) throw new Error("Sign in to access the Edu release.");

  const response = await axios.get(`${baseURL.replace(/\/$/, "")}/builds/current`, {
    params: { app: "10kScience", channel, platform: "android", buildName: "10kScienceEdu" },
    headers: { Authorization: `Bearer ${token}` },
    signal,
    timeout: 20000,
  });
  const build = response.data?.data;
  if (
    build?.app !== "10kScience" || build.channel !== channel ||
    build.platform !== "android" || build.buildName !== "10kScienceEdu" ||
    build.status !== "PROMOTED" || !build.version
  ) {
    throw new Error("The returned release is not a promoted 10k Science Edu build.");
  }

  const apk = build.files?.find((file) => {
    if (!file?.path?.toLowerCase().endsWith(".apk")) return false;
    try {
      return new URL(file.url).protocol === "https:";
    } catch {
      return false;
    }
  });
  if (!apk) throw new Error("The Edu release does not have an APK download.");

  return {
    version: build.version,
    publishedAt: build.promotedAt,
    sizeBytes: apk.sizeBytes,
    fileName: apk.path.split("/").pop(),
    downloadUrl: apk.url,
  };
}
